import script from "./EmployeeList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeList.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeList.vue?vue&type=style&index=0&id=1218ea90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1218ea90"]])

export default __exports__